import React, { useEffect, useState } from "react";

// Chakra imports
import {
  Flex,
  Table,
  Tbody,
  Box,
  Button,
  Th,
  Thead,
  Tr,
  Td,
  Input,
  Spacer,
  Select,
  Text,
  SimpleGrid,
  Stack,
  HStack,
} from "@chakra-ui/react";

// Custom components
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import { usePaginateComponent } from "components/Pagination/pagination";

// Icons
import { AiFillCheckCircle } from "react-icons/ai";
import { getUsers } from "service/users.service";
import { useHistory } from "react-router-dom";
import { ROLES_STATUS, VERIFICATION_STATUS } from "../../constants";
import { useAppToast } from "utils/toastUtil";

export default function Users() {
  const history = useHistory();
  const [users, setUsers] = useState([]);

  const [searchUser, setSearchUser] = useState("");
  const [selectedRole, setSelectedRole] = useState("");
  const [verificationUsers, setVerificationUsers] = useState({
    verified: "",
    unverified: "",
  });
  const {
    pagination,
    setPagination,
    PaginationComponent,
    updatePagination,
  } = usePaginateComponent();
  const { showToast } = useAppToast();

  const getUserList = async (page) => {
    const { data, total_unverified, total_verified } = await getUsers(
      page ?? 1,
      searchUser,
      selectedRole
    );

    setPagination(updatePagination(data));

    setUsers(data.data);
    handleVerifiedUsers(total_unverified, total_verified);
  };

  const handleVerifiedUsers = (total_unverified, total_verified) => {
    setVerificationUsers({
      ...verificationUsers,
      verified: total_verified,
      unverified: total_unverified,
    });
  };

  useEffect(() => {
    getUserList();
  }, [searchUser, selectedRole]);

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      {/* KYC Table */}
      <Card overflowX={{ sm: "scroll" }} pb="0px">
        <Spacer />
        <CardHeader p="6px 0px 22px 0px">
          <Stack w={"full"} overflow={"auto"}>
            <Flex w={"full"}>
              <Box p={"2"} w={"full"}>
                <Input
                  placeholder={"Search. . ."}
                  onChange={(e) => {
                    setSearchUser(e.target.value);
                  }}
                  textColor={"black"}
                  bg={"white"}
                />
              </Box>
              <Select
                py={"2"}
                maxW={"300px"}
                placeholder="Role"
                bg={"white"}
                fontSize={"xs"}
                fontWeight={"bold"}
                textTransform={"uppercase"}
                onChange={(e) => {
                  setSelectedRole(e.target.value);
                }}
              >
                {Object.entries(ROLES_STATUS).map(([key, value]) => (
                  <option key={key} value={value}>
                    {value}
                  </option>
                ))}
              </Select>
            </Flex>

            <SimpleGrid px={"4"} columns={"4"} w={"full"} gap={"4"}>
              <Text textColor={"white"}>Verified</Text>
              <Text
                textColor={"green"}
                textAlign={"left"}
                fontSize={"lg"}
                fontWeight={"bold"}
              >
                {verificationUsers.verified}
              </Text>
              <Text textColor={"white"}>Unverified</Text>
              <Text
                textColor={"yellow"}
                textAlign={"left"}
                fontSize={"lg"}
                fontWeight={"bold"}
              >
                {verificationUsers.unverified}
              </Text>
            </SimpleGrid>

            <PaginationComponent pagination={pagination} getListData={getUserList} />
          </Stack>
        </CardHeader>
        <CardBody>
          <Table variant="simple" color="#fff">
            <Thead>
              <Tr my=".8rem" ps="0px" color="gray.400">
                <Th
                  ps="0px"
                  color="gray.400"
                  fontFamily="Plus Jakarta Display"
                  borderBottomColor="#56577A"
                >
                  ID
                </Th>
                <Th
                  ps="0px"
                  color="gray.400"
                  fontFamily="Plus Jakarta Display"
                  borderBottomColor="#56577A"
                >
                  No.
                </Th>
                <Th
                  ps="0px"
                  color="gray.400"
                  fontFamily="Plus Jakarta Display"
                  borderBottomColor="#56577A"
                >
                  FULL NAME
                </Th>
                <Th
                  color="gray.400"
                  fontFamily="Plus Jakarta Display"
                  borderBottomColor="#56577A"
                >
                  USERNAME/NICKNAME
                </Th>
                <Th
                  color="gray.400"
                  fontFamily="Plus Jakarta Display"
                  borderBottomColor="#56577A"
                >
                  EMAIL
                </Th>
                <Th
                  color="gray.400"
                  fontFamily="Plus Jakarta Display"
                  borderBottomColor="#56577A"
                >
                  PHONE
                </Th>
                <Th
                  color="gray.400"
                  fontFamily="Plus Jakarta Display"
                  borderBottomColor="#56577A"
                >
                  ROLE
                </Th>
                {/* <Th
                  color="gray.400"
                  fontFamily="Plus Jakarta Display"
                  borderBottomColor="#56577A"
                >
                  Date Verified
                </Th>
                <Th borderBottomColor="#56577A"></Th> */}
              </Tr>
            </Thead>
            <Tbody>
              {users.map((user, index, arr) => {
                const userProfile = user?.profile;
                return (
                  <Tr
                    key={user.id}
                    cursor={"pointer"}
                    onClick={() => {
                      history.push({
                        pathname: "/admin/users/detail",
                        state: user,
                      });
                    }}
                  >
                    <Td pl={0}>#{user.id}</Td>
                    <Td pl={0}>{index + 1}</Td>
                    <Td pl={0}>{userProfile?.full_name}</Td>
                    <Td>{userProfile?.nickname}</Td>
                    <Td>{userProfile?.contact_email}</Td>
                    <Td>{userProfile?.contact_phone}</Td>
                    <Td>{ROLES_STATUS[user.role_id]}</Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </CardBody>
      </Card>
    </Flex>
  );
}
